import { memo } from 'react';

import withComponentName from '../../../../../decorators/withComponentName';

import premiumContentImage from '../../../../../assets/homepage/premium-content-computer.svg';
import Styles from '../styles.module.scss';
import positiveFeatureImg from '../../../../../assets/homepage/circle-plus.svg';
import negativeFeatureImg from '../../../../../assets/homepage/circle-minus.svg';
import PlayVideoComponent from '../../../../PlayVideoComponent';

export const PremiumContentPublications = () => (
  <section className={Styles['premium-content-publications']}>
    <div className={Styles['premium-publications-title']}>
      <h1 className={`${Styles.title} text-uppercase`}>
        Enjoy 1000+ Premium Publications Among Our 11000+ Sources
        <PlayVideoComponent
          videoLink="https://cityfalcon.wistia.com/medias/nq8g9ra0th"
          videoLinkMobile="https://cityfalcon.wistia.com/medias/el5pzya155"
          additionalStyles={Styles.premium_play_button}
          tooltipAdditionalContentStyle={Styles.premium_play_button_tooltip}
        />
      </h1>
      <p className={Styles.institutions}>
        Including Select Paywall-free and Non-public Content from
        <br />
        Washington Post, The Economist, and
        {' '}
        <a href="https://help.cityfalcon.com/hc/en-us/articles/360034657073" target="_blank" rel="noopener noreferrer">Many More</a>
      </p>
    </div>
    <div className={Styles['premium-content-publication-img']}>
      <img
        src={premiumContentImage}
        alt=""
        loading="lazy"
      />
    </div>
    <div className={Styles['premium-content-features']}>
      <div className={Styles['negative-features']}>
        <img
          width={67}
          height={67}
          src={negativeFeatureImg}
          alt=""
        />
        <ul>
          <li>No advertisements or clutter</li>
          <li>No additional registrations or paywalls</li>
        </ul>
      </div>
      <div className={Styles['positive-features']}>
        <img
          width={67}
          height={67}
          src={positiveFeatureImg}
          alt=""
        />
        <ul>
          <li>Content loads in milliseconds</li>
          <li>Offline reading</li>
        </ul>
      </div>
    </div>
  </section>
);

export default withComponentName(memo(PremiumContentPublications));
